<template>
  <div class="route_middel">
    
  </div>
</template>

<script>
export default {
  name: 'route_middel',
  props: {
    msg: String
  },
  data() {
    return {
      
    };
  },
  created() {
    var that = this;
    var options = this.$route.params;
    if(!options.type) {
      options = this.$route.query;
    }
    var name = "";
    if(options.type=="look") {
      name = "look";
    } else if(options.type=="new_list") {
      name = "new_list";
    } else if(options.type=="doExamPaper") {
      name = "vueDoExamPaper"
    }
    var goBackState = localStorage.goBackState;
    if(name != "" && goBackState != "true") {
      this.$route.params.type = "back";
      that.$router.push({ 
        name: name, 
          query: {
            kw_param:options.kw_param
          }
      });
    } else if(goBackState == "true") {
      localStorage.goBackState = "false";
      console.log("routerMiddel==========localStorage.goBackState==========",localStorage.goBackState);
      that.$router.back();
    }
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
